import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly dialog = inject(MatDialog);

  open<T>(
    component: ComponentType<T> | TemplateRef<T>,
    options: MatDialogConfig,
  ) {
    return this.dialog.open(component, options);
  }
}
